import service, {
  ApiError,
  isApiError,
  getToken,
  setToken,
  interceptors
} from './request.js'

export class Api {
  constructor(req) {
    const s = req || service

    this.request = s
    this.ad = {
      // 统一拉取某场景广告素材：{ list: [{ adType, imageUrl?, title?, desc?, text?, jumpUrl?, qrImageUrl?, token? }] }
      getAd: (scene, params = {}) => s.get('/ad', { scene, ...params }),
      // 激励广告「我已看完」校验（token 由 reward 项下发，防重放）：{ ok, rewardName?, point? }
      verifyReward: (payload = {}) => s.post('/ad/reward/verify', payload)
    }
    this.ocr = {
      // 识别裁剪图片文字（multipart，字段 image）：{ text, lines:[{ text, confidence, box? }] }
      recognizeImage: (filePath, options = {}) =>
        s.upload('/ocr/recognize', {
          filePath,
          name: 'image',
          formData: options.lang ? { lang: options.lang } : {}
        })
    }
  }
}

export const api = new Api()

export { service, ApiError, isApiError, getToken, setToken, interceptors }
export default api
